<template>
    <div>
        <FlashNotification />

        <h2 class="title is-2">
            Viewing Availability
        </h2>

        <LeadProperty>
            What's your availability for a property viewing?
        </LeadProperty>

        <table class="table is-bordered is-striped is-fullwidth">
            <AvailabilityDateRow
                v-for="(n, index) in 7"
                :key="index"
                :date-number="n"
            />
        </table>

        <b-button
            type="is-info"
            tag="button"
            native-type="submit"
            @click="advance"
        >
            Save
        </b-button>
    </div>
</template>

<script>
import AvailabilityDateRow from '../../components/AvailabilityDateRow.vue';
import FlashNotification from '../../components/FlashNotification.vue';
import LeadProperty from '../../components/LeadProperty.vue';

export default {
    components: {
        FlashNotification,
        AvailabilityDateRow,
        LeadProperty,
    },

    methods: {
        advance() {
            this.$router.push({
                name: 'lead-complete',
                params: {
                    message: 'Viewing availability has been saved.',
                },
            });
        },
    },
};
</script>
